export const DESKTOP_CATEGORY_THRESHOLD = 500;
export const SELECT_OPTION = '<< Select >>';
export const PAST_PAPERS_CATEGORY_NAME = 'Past Papers';
export const QS_BY_TOPIC_CATEGORY_NAME = 'Qs by Topic'; 
export const VIDEOS_CATEGORY_NAME = 'Videos';

export const STUDY_MIND_LINK_5 = "https://studymind.co.uk/gcse-science-tutors/?utm_source=referral&utm_medium=email&utm_campaign=cognito_tutoring_70_5&utm_term=button&utm_content=cognito_tutoring_70_5";

